import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecaptchaModule } from "ng-recaptcha";

import { CateringSiteRoutingModule } from './catering-site-routing.module';
import { CateringSiteComponent } from './catering-site.component';

import { SwiperModule } from 'swiper/angular';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';

import { HomepageComponent } from './components/homepage/homepage.component';
import { TeamComponent } from './components/team/team.component';
import { AboutComponent } from './components/about/about.component';
import { GalleryComponent } from './components/gallery/gallery.component';
import { ContactComponent } from './components/contact/contact.component';
import { MenuComponent } from './components/nav-menu/menu.component';
import { AudienceListComponent } from './components/menu/audience-list/audience-list.component';
import { MealsetComponent } from './components/menu/mealset/mealset.component';
import { MealsetSectionComponent } from './components/menu/mealset-section/mealset-section.component';
import { MealsetOptionsComponent } from './components/menu/mealset-options/mealset-options.component';
import { MealsetVariablePriceComponent } from './components/menu/mealset-variable-price/mealset-variable-price.component';

import { AudienceViewComponent } from './components/menu/audience-view/audience-view.component';

import { CleanPricePipe } from '@shared/pipe/clean-price.pipe';
import { PoliciesComponent } from './components/policies/policies.component';

import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from '@angular/material/tooltip';

@NgModule({
  declarations: [
    CateringSiteComponent,
    HomepageComponent,
    TeamComponent,
    AboutComponent,
    GalleryComponent,
    ContactComponent,
    MenuComponent,
    AudienceListComponent,
    MealsetComponent,
    MealsetSectionComponent,
    MealsetOptionsComponent,
    MealsetVariablePriceComponent,
    AudienceViewComponent,
    CleanPricePipe,
    PoliciesComponent
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    SwiperModule,
    CommonModule,
    CateringSiteRoutingModule,
    RecaptchaModule,
    MatProgressSpinnerModule,
    MatTooltipModule
  ]
})
export class CateringSiteModule { }
